import useTranslation from 'next-translate/useTranslation';

import log from '~/common/utils/log';
import { useIsMobile } from '~/domains/common/hooks/mediaQueries';

export const useShowCommissionerEmailListPopup = () => {
  const { t } = useTranslation('common');
  const message = t('getEmailListIntercom');
  const isMobile = useIsMobile();

  const showIntercom = () => {
    // @ts-expect-error: components/Intercom/IntercomLoggedIn.tsx
    if (window.Intercom && !isMobile) {
      // @ts-expect-error: components/Intercom/IntercomLoggedIn.tsx
      window.Intercom('showNewMessage', message);
    } else {
      log('Intercom not available');
    }
  };

  return showIntercom;
};
